import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { colFlexStyle, commonContainerWrapper } from "../../Common/styles/flex";
import { useParams } from "react-router-dom";
import http from "../../../utils/http";
import { errorToastMessage } from "../../../utils/toast";
// import DownloadList from "../DownloadList";
// import SyncDates from "../SyncDates";
// import DownloadSelectorModal from "../Modals/DownloadSelectorModal";
import { useAppSelector } from "../../../Redux/hooks";
// import { featuresMap } from "../../../utils/features";
// import PatientQRModal from "../Modals/PatientQRModal";
import TagsCard from "../ParticipantTags/TagsCard";
import RedactionHistoryModal from "../../PlatformParticipant/Modals/RedactionHistoryModal";
import NotesList from "../ParticipantNotes/NotesList";
import { permissions } from "../../../utils/roles";
import { DateTime } from "luxon";
import { canMutateStudyParticipantTagsNotes } from "../../../utils/participantLock";

const ParticipantDetails = ({
  showDownloadModal,
  setShowDownloadModal,
}: any) => {
  // const features = useAppSelector((state) => state.study.features);
  // const isWearable = features?.[featuresMap.wearable];
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>({});
  const { id: studyId, participantId } = useParams();
  const [toggleLoader, setToggleLoader] = useState(false);
  const [showRedactionHistory, setShowRedactionHistory] = useState(false);
  // const [toggleReload, setToggleReload] = useState<boolean>(false);
  // const [toggleSyncReload, setToggleSyncReload] = useState<boolean>(false);
  // const [showQR, setShowQR] = useState<boolean>(false);
  const sitePermissions = useAppSelector(
    (state) => state.study.sitePermissions
  );
  const dataEditable = useAppSelector((state) => state.study.dataEditable);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        setLoading(true);
        let url = `/participants/${participantId}?studyId=${studyId}`;
        const res = await http.get(url);
        const userRes = res?.data?.data;
        let newData: any = {};
        newData = {
          firstName: userRes?.firstName,
          lastName: userRes?.lastName,
          email: userRes?.email || "-",
          siteName: userRes?.site?.name || "-",
          subjectId: userRes?.formattedSubjectId ?? userRes?.site?.abbreviation,
          joinCode: userRes?.studyParticipant?.joinCode || null,
          groupCode: userRes?.groupCode || null,
          tags:
            userRes?.tags?.map((tag: any) => ({
              id: tag?.tag?.id,
              name: tag?.tag?.name,
              studyId: tag?.studyId,
            })) || [],
          canEdit: canMutateStudyParticipantTagsNotes({
            hasEditPermission:
              !!sitePermissions?.[
                userRes?.site?.id || ""
              ]?.permissions?.includes(permissions.editParticipant),
            dataEditable,
            isLocked: userRes?.isLocked,
            isArchived: userRes?.isArchived,
            isExcluded: userRes?.eligibilityStatus === "excluded",
            isWithdrawn: userRes?.eligibilityStatus === "withdrawn",
            redactionStatus: userRes?.redactionStatus,
          }),
          phoneNumber: userRes?.phoneNumber,
          gender: userRes?.gender,
          dob: userRes?.dob
            ? DateTime.fromFormat(userRes?.dob, "yyyy-MM-dd").toFormat(
                "MM/dd/yyyy"
              )
            : "",
          occupation: userRes?.occupation,
          address: userRes?.address,
          lastParticipationDate: userRes?.lastParticipationDate
            ? DateTime.fromISO(userRes?.lastParticipationDate).toFormat(
                "MM/dd/yyyy"
              )
            : "",
          lastStudyDate: userRes?.lastStudyDate
            ? DateTime.fromISO(userRes?.lastStudyDate).toFormat("MM/dd/yyyy")
            : "",
          redactionStatus: userRes?.redactionStatus,
        };
        setData(newData);

        setLoading(false);
      } catch (err) {
        errorToastMessage(err as Error);
        setLoading(false);
      }
    };

    fetchDetails();
  }, [studyId, participantId, toggleLoader, sitePermissions, dataEditable]);

  const refreshDetails = () => {
    setToggleLoader((prev) => !prev);
  };

  // function refreshPage() {
  //   setToggleReload((prev) => !prev);
  // }
  // function toggleSyncRefresh() {
  //   setToggleSyncReload((prev) => !prev);
  // }

  function closeDownloadModal() {
    setShowDownloadModal(false);
  }

  // const openQRModal = () => {
  //   setShowQR(true);
  // };

  // const closeQRModal = () => {
  //   setShowQR(false);
  // };

  return (
    <>
      {loading ? (
        <Stack
          sx={{
            flex: 1,
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress color="primary" />
        </Stack>
      ) : (
        <Box sx={{ p: 2.5, height: "calc(100vh - 136px)", overflow: "scroll" }}>
          <Box sx={commonContainerWrapper}>
            <Typography variant="h2" color="text.primary">
              Participant Details
            </Typography>
            <Box sx={{ ...colFlexStyle, gap: 3, my: 3 }}>
              {data?.firstName && (
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={"regular"}
                      color="text.primary"
                    >
                      First Name
                    </Typography>
                    <Typography variant="subtitle1" color="text.primary">
                      {data?.firstName}
                    </Typography>
                  </Box>
                  <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={"regular"}
                      color="text.primary"
                    >
                      Last Name
                    </Typography>
                    <Typography variant="subtitle1" color="text.primary">
                      {data?.lastName}
                    </Typography>
                  </Box>
                </Box>
              )}
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"regular"}
                    color="text.primary"
                  >
                    Email
                  </Typography>
                  <Typography variant="subtitle1" color="text.primary">
                    {data?.email || "-"}
                  </Typography>
                </Box>

                <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"regular"}
                    color="text.primary"
                  >
                    Phone Number
                  </Typography>
                  <Typography variant="subtitle1" color="text.primary">
                    {data?.phoneNumber || "-"}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                }}
              >
                <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"regular"}
                    color="text.primary"
                  >
                    Site
                  </Typography>
                  <Typography variant="subtitle1" color="text.primary">
                    {data?.siteName}
                  </Typography>
                </Box>
                <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"regular"}
                    color="text.primary"
                  >
                    Join Code
                  </Typography>
                  <Typography variant="subtitle1" color="text.primary">
                    {data?.joinCode || "-"}
                  </Typography>
                </Box>
                <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"regular"}
                    color="text.primary"
                  >
                    Group Code
                  </Typography>
                  <Typography variant="subtitle1" color="text.primary">
                    {data?.groupCode || "-"}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                }}
              >
                <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"regular"}
                    color="text.primary"
                  >
                    Study Completion Date
                  </Typography>
                  <Typography variant="subtitle1" color="text.primary">
                    {data?.lastParticipationDate || "-"}
                  </Typography>
                </Box>
                <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"regular"}
                    color="text.primary"
                  >
                    Last Study Participation in Registry
                  </Typography>
                  <Typography variant="subtitle1" color="text.primary">
                    {data?.lastStudyDate || "-"}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                }}
              >
                <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"regular"}
                    color="text.primary"
                  >
                    Gender
                  </Typography>
                  <Typography variant="subtitle1" color="text.primary">
                    {data?.gender || "-"}
                  </Typography>
                </Box>
                <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"regular"}
                    color="text.primary"
                  >
                    DOB
                  </Typography>
                  <Typography variant="subtitle1" color="text.primary">
                    {data?.dob || "-"}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                <Typography
                  variant="subtitle1"
                  fontWeight={"regular"}
                  color="text.primary"
                >
                  Occupation
                </Typography>
                <Typography variant="subtitle1" color="text.primary">
                  {data?.occupation || "-"}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                }}
              >
                <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"regular"}
                    color="text.primary"
                  >
                    Address Line 1
                  </Typography>
                  <Typography variant="subtitle1" color="text.primary">
                    {data?.address?.line1 || "-"}
                  </Typography>
                </Box>
                <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"regular"}
                    color="text.primary"
                  >
                    Address Line 2
                  </Typography>
                  <Typography variant="subtitle1" color="text.primary">
                    {data?.address?.line2 || "-"}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                }}
              >
                <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"regular"}
                    color="text.primary"
                  >
                    City
                  </Typography>
                  <Typography variant="subtitle1" color="text.primary">
                    {data?.address?.city || "-"}
                  </Typography>
                </Box>
                <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"regular"}
                    color="text.primary"
                  >
                    State
                  </Typography>
                  <Typography variant="subtitle1" color="text.primary">
                    {data?.address?.state || "-"}
                  </Typography>
                </Box>
                <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"regular"}
                    color="text.primary"
                  >
                    Country
                  </Typography>
                  <Typography variant="subtitle1" color="text.primary">
                    {data?.address?.country || "-"}
                  </Typography>
                </Box>
                <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"regular"}
                    color="text.primary"
                  >
                    Zip Code
                  </Typography>
                  <Typography variant="subtitle1" color="text.primary">
                    {data?.address?.zipcode || "-"}
                  </Typography>
                </Box>
              </Box>
              {/* <Box>
                <Button variant="contained" onClick={openQRModal}>
                  Show QR
                </Button>
              </Box> */}
              {data?.redactionStatus && (
                <Box>
                  <Button
                    variant="outlined"
                    onClick={() => setShowRedactionHistory(true)}
                  >
                    Redaction History
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
          <TagsCard
            tagsList={data?.tags}
            refreshPage={refreshDetails}
            canEdit={data?.canEdit}
          />
          <NotesList canEdit={data?.canEdit} />
          {/* {isWearable && (
            <>
              <DownloadList
                toggleReload={toggleReload}
                refreshPage={refreshPage}
              />
              <Box>
                <SyncDates
                  toggleReload={toggleSyncReload}
                  refreshPage={toggleSyncRefresh}
                />
              </Box>
            </>
          )} */}
        </Box>
      )}
      {/* {showDownloadModal && (
        <DownloadSelectorModal
          showModal={showDownloadModal}
          handleClose={closeDownloadModal}
          refreshPage={refreshPage}
        />
      )} */}
      {/* {showQR && (
        <PatientQRModal showModal={showQR} closeModal={closeQRModal} />
      )} */}
      {showRedactionHistory && (
        <RedactionHistoryModal
          open={showRedactionHistory}
          onClose={() => setShowRedactionHistory(false)}
          participantId={participantId as string}
          currentStatus={
            (data?.redactionStatus as
              | "active"
              | "deactivated"
              | "redacted"
              | "deleted") ?? "active"
          }
        />
      )}
    </>
  );
};

export default ParticipantDetails;
